/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class HealthFindrApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `HealthFindrModule.forRoot()`
 */
export interface HealthFindrApiConfigurationParams {
  rootUrl?: string;
}
